import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ReplayCircleFilledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"replay_circle_filled"}/>
}
